import React from 'react'
import PropTypes from 'prop-types'

class Error extends React.Component {
  render() {
    let { name, ...other } = this.props
    let touched = this.context.form.touched[name]
    let error = this.context.form.errors[name]

    if (touched && error) {
      return (
        <div {...other}>{error}</div>
      )
    }

    return (null)
  }
}

Error.propTypes = {
  name: PropTypes.string.isRequired
}

Error.contextTypes = {
  form: PropTypes.object.isRequired
}

export default Error



// WEBPACK FOOTER //
// ./src/components/Form/Error/index.js